"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListOfShipToAddresses = void 0;

var common_enums_1 = require("@ryerson/common.enums");

var getListOfShipToAddresses = function getListOfShipToAddresses(shipToAddresses) {
  var addresses = [];
  shipToAddresses === null || shipToAddresses === void 0 ? void 0 : shipToAddresses.forEach(function (address) {
    if (address.addressCategory === common_enums_1.CommonShipmentEnum.AddressCategory.ShipTo) {
      var displayAddress = {
        display: "".concat(address.companyName, ", ").concat(address.address1, " ").concat(address.address2, ", ").concat(address.city, ", ").concat(address.state, " ").concat(address.zipCode, ", ").concat(address.country),
        value: JSON.stringify(address)
      };
      addresses.push(displayAddress);
    }
  });
  return addresses;
};

exports.getListOfShipToAddresses = getListOfShipToAddresses;